module.exports = __webpack_public_path__ + "static/media/nickles4.effd3ba2.jpg";